export enum EBonusStatus {
  Init = 'init',
  Applied = 'applied',
  Awarded = 'awarded',
  Canceled = 'canceled',
  Error = 'error',
}
